const env = typeof process !== 'undefined' ? process.env : {};

export const API_URL = env.REACT_APP_API_URL
    || env.EXPO_PUBLIC_API_URL
    || 'http://localhost:8080';

export const apiUrl = (path) => `${API_URL.replace(/\/$/, '')}/${String(path).replace(/^\//, '')}`;
